import { SegmentListEvent, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { listSetMaxCardNumber } from '../../../../../../../../rest/effects/list/listSetMaxCardNumber';
import {Dispatch, ThunkAction} from '../../../../../../../../types/actions';

export const onSaveLimit = (
    listId: number,
    value: number,
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        dispatch(segmentTrackAction(SegmentListEvent.CARD_LIMIT));
        dispatch(listSetMaxCardNumber(listId, value));
    };
    return action
};
